import { atom } from 'recoil';

export const useUserState = atom({
  key: 'useUserState',
  default: null,
});
